<template>
  <div>
    <div>
      <div v-for="(item, index) in visits.data" :key="'register-visit' + index">
        <validation-observer ref="registerVisitForm" novalidate tag="form">
          <custom-callout
            v-if="
              index != visits.data.length - 1 ||
                (index == visits.data.length - 1 && !isReadOnly)
            "
            class="mb-3 custom-callout"
            :controlled="true"
            :opened="item.isOpen"
            @click:open="onToggleAdditionalInfo(item, index)"
          >
            <div class="row">
              <div class="col-md-1 col-sm-12 col-spacing hour-size">
                <div class="color-secondary-6 font-weight-normal font-14">
                  Día:
                </div>
                <validation-provider
                  v-if="!item.saved"
                  v-slot="{ errors }"
                  name="Día"
                  rules="required"
                >
                  <custom-input
                    v-model="item.day"
                    class="hour-size"
                    custom-error-msg=""
                    :error="errors[0]"
                    mask-type="Day"
                    type="text"
                    @input="evalEnterDay(item, index)"
                  />
                </validation-provider>
                <span v-else class="color-black">{{ item.day }}</span>
              </div>
              <div class="col-md-3 col-sm-12 col-spacing">
                <div
                  v-if="!item.saved"
                  class="color-secondary-6 font-weight-normal font-14"
                >
                  Hora Desde:
                </div>
                <div
                  v-else
                  class="color-secondary-6 font-weight-normal font-14"
                >
                  Hora:
                </div>
                <div v-if="!item.saved" class="d-flex">
                  <validation-provider
                    v-slot="{ errors }"
                    name="HourStartHour"
                    rules="required"
                  >
                    <custom-input
                      v-model="item.hourStartHour"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                      @input="evalEnterHour(item, index)"
                    />
                  </validation-provider>
                  <span class="mr-3 mt-1">:</span>
                  <validation-provider
                    v-slot="{ errors }"
                    name="HourStartMinute"
                    rules="required"
                  >
                    <custom-input
                      v-model="item.hourStartMinute"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                      @input="evalEnterMinute(item, index)"
                    />
                  </validation-provider>
                  <b-form-select
                    v-model="item.hourStartTime"
                    class="ampm-size"
                    :disabled="disableAmPm(item, index)"
                    :options="catalog.timeOptions"
                    @input="evalEnterAmPm(item, index)"
                  />
                </div>
                <div v-else>
                  <span class="color-black">
                    {{ getHourRange(item) }}
                  </span>
                </div>
              </div>
              <div v-if="!item.saved" class="col-md-3 col-sm-12 col-spacing">
                <div class="color-secondary-6 font-weight-normal font-14">
                  Hora Hasta:
                </div>
                <div
                  v-if="!item.saved && !showHasta"
                  class="font-weight-normal text-black mt-2"
                >
                  <label>{{ item.hourEnd }}</label>
                </div>
                <div v-if="!item.saved && showHasta" class="d-flex">
                  <validation-provider
                    v-slot="{ errors }"
                    name="hourEnd"
                    rules="required"
                  >
                    <custom-input
                      v-model="item.hourEnd"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                    />
                  </validation-provider>
                  <span class="mr-3 mt-1">:</span>
                  <validation-provider
                    v-slot="{ errors }"
                    name="hourEndMinute"
                    rules="required"
                  >
                    <custom-input
                      v-model="item.hourEndMinute"
                      class="hour-size"
                      custom-error-msg=""
                      :error="errors[0]"
                      mask-type="Day"
                      type="text"
                      @input="evalEnterAmPm(item, index)"
                    />
                  </validation-provider>
                  <b-form-select
                    v-model="item.hourEndTime"
                    class="ampm-size"
                    :options="catalog.timeOptions"
                    @input="evalEnterAmPm(item, index)"
                  />
                </div>
              </div>
              <div class="col-md-3 col-spacing">
                <div class="color-secondary-6 font-weight-normal font-14">
                  Tipo:
                </div>
                <span v-if="!item.saved">
                  <ValidationProvider
                    v-slot="{ errors }"
                    name="SelectedType"
                    rules="required"
                  >
                    <CustomDropDown
                      v-model="item.selectedType"
                      :disabled="
                        item.id ||
                          visitTypesOptions.length === 0 ||
                          item.day === undefined ||
                          false ||
                          item.day === ''
                      "
                      :error="errors[0]"
                      fieldkey="id"
                      fieldname="name"
                      :options="visitTypesOptions"
                      @input="onChangeVisitType(item, index)"
                    />
                  </ValidationProvider>
                  <div
                    v-if="
                      item.selectedType && item.selectedType.showPreviousYears
                    "
                  >
                    <span class="color-secondary-6 font-weight-normal font-14">
                      Año Anterior:
                    </span>
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <CustomDropDown
                        v-model="item.previousAcademicYear"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        :options="previousAcademicYears"
                        @input="onPreviousAcademicYearChanged(item)"
                      />
                    </ValidationProvider>
                  </div>
                  <div
                    v-if="
                      item.selectedType &&
                        item.selectedType.showPreviousYears &&
                        filteredPreviousCompensatories.length > 0 &&
                        item.previousAcademicYear &&
                        item.previousAcademicYear.id > 0
                    "
                  >
                    <span class="color-secondary-6 font-weight-normal font-14">
                      Solicitud:
                    </span>
                    <ValidationProvider v-slot="{ errors }" rules="required">
                      <CustomDropDown
                        v-model="item.compensatoryRequestSelected"
                        :error="errors[0]"
                        fieldkey="id"
                        fieldname="name"
                        :options="filteredPreviousCompensatories"
                      />
                    </ValidationProvider>
                  </div>
                </span>
                <span v-else class="color-black">
                  {{ getItemName(item.selectedType) }}
                  {{
                    item.selectedType && item.selectedType.showPreviousYears
                      ? getItemName(item.previousAcademicYear)
                      : null
                  }}
                </span>
              </div>
              <div v-if="item.saved" class="col-md-3 col-spacing">
                <div
                  v-if="validateSelectedVisitInfoJustification(item)"
                  class="color-secondary-6 font-weight-normal font-14"
                >
                  Justificación:
                </div>
                <span class="color-black">
                  {{ getItemName(item.selectedVisitInfoJustification) }}
                </span>
              </div>
              <div
                v-if="!isPeriodFinalized"
                class="col-md-1 col-sm-12 justify-content-end align-items-center pt-4"
              >
                <div
                  v-if="enableActionMenu(item) && !item.enableReplaceSpecialist"
                  class="dropdown"
                >
                  <button
                    v-if="!isReadOnly"
                    id="dropdownMenuButton"
                    aria-expanded="false"
                    aria-haspopup="true"
                    class="btn btn-dropdown-actions dropdown-toggle float-right pt-1"
                    data-toggle="dropdown"
                    type="button"
                  >
                    Acciones
                  </button>
                  <div
                    aria-labelledby="dropdownMenuButton"
                    class="dropdown-menu dropdown-menu-right custom-dropdown-container"
                  >
                    <div
                      v-if="canShowEditVisit(item)"
                      class="dropdown-item cursor-pointer mb-1"
                      @click="editVisit(item, index)"
                    >
                      <em class="fa fa-pencil text-green pr-1" />
                      <span>Editar Visita</span>
                    </div>
                    <div
                      v-if="canShowDeleteVisit(item)"
                      class="dropdown-item cursor-pointer"
                      @click="onDeleteVisit(item.id, index)"
                    >
                      <em class="fa fa-times-circle text-red pr-1" />
                      <span>Eliminar Visita</span>
                    </div>
                    <hr class="mt-2" />
                    <div
                      class="dropdown-item cursor-pointer mt-n2"
                      @click="replaceServicePlace(item, index)"
                    >
                      <em class="fa fa-exchange text-green pr-1" />
                      <span>Reemplazar Lugar de Servicio y/o Especialista</span>
                    </div>
                  </div>
                </div>
                <div v-if="enableActionButton(item)" class="mt-n3">
                  <action-button
                    v-if="
                      (!item.saved && item.id) || item.enableReplaceSpecialist
                    "
                    class="px-4 mt-4"
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger"
                    @click="onCancelEdit(item, index)"
                  >
                    Cancelar
                  </action-button>
                  <action-button
                    class="px-4 mt-4"
                    i="fas fa-plus"
                    text="Guardar"
                    variant="success"
                    @click="handleSaveVisit(item, item.id, index)"
                  />
                </div>
              </div>
              <div
                v-if="
                  item.hasOverrideLocationType || item.hasOverrideSpecialist
                "
                class="col-md-12 mt-n2"
              >
                <visit-tag
                  v-if="item.hasOverrideLocationType"
                  color="orange"
                  icon="fas fa-map-marker-edit"
                  label="Reemplazo de Lugar de Servicio"
                  type="red"
                />
                <visit-tag
                  v-if="item.hasOverrideSpecialist"
                  color="green"
                  icon="fas fa-user-md"
                  label="Reemplazo de Especialista"
                  type="green"
                />
              </div>
            </div>
            <template
              v-if="item.selectedType"
              #edition
              class="p-3 pb-2 custom-callout-edition"
            >
              <div class="bg-secondary-9 p-2">
                <div class="info-panel bg-white rounded pb-3">
                  <b-tabs
                    active-nav-item-class="mipe-tab font-weight-bold text-green active-nav-item-custom"
                    active-tab-class=""
                    content-class="mt-3"
                    nav-class="custom-nav-container"
                    :no-nav-style="true"
                  >
                    <b-tab
                      v-if="hideVisitAdditionalInformation(item.selectedType)"
                      :active="
                        item.selectedTab ==
                          additionalInfoTabs.VISIT_ADDITIONAL_INFO
                      "
                      title="Información Adicional de Visita"
                    >
                      <div class="row mx-4">
                        <div
                          v-if="enableRepositionDate(item.selectedType)"
                          class="col"
                        >
                          <div class="color-secondary-6">
                            Fecha a Reponer:
                          </div>
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                          >
                            <custom-drop-down
                              v-model="item.selectedVisitInfoDateReposition"
                              :disabled="item.saved || !canEditReposition"
                              :error="errors[0]"
                              fieldkey="id"
                              fieldname="name"
                              :options="repositions"
                              placeholder="Seleccione"
                            />
                          </validation-provider>
                        </div>
                        <div
                          v-if="enableJustification(item.selectedType)"
                          class="col"
                        >
                          <div class="color-secondary-6">
                            Justificación:
                          </div>
                          <validation-provider
                            v-slot="{ errors }"
                            rules="required"
                          >
                            <custom-drop-down
                              v-model="item.selectedVisitInfoJustification"
                              :disabled="item.saved"
                              :error="errors[0]"
                              fieldkey="id"
                              fieldname="name"
                              :options="filteredAbsences"
                              placeholder="Seleccione"
                            />
                          </validation-provider>
                        </div>
                        <div
                          v-if="enableComment(item.selectedType)"
                          class="col"
                          :class="[
                            {
                              'col-md-12 mt-3':
                                enableJustification(item.selectedType) &&
                                enableRepositionDate(item.selectedType),
                            },
                          ]"
                        >
                          <div class="color-secondary-6">
                            Comentario:
                          </div>
                          <validation-provider
                            v-slot="{ errors }"
                            :rules="getCommentRule(item)"
                          >
                            <custom-text-area
                              v-model="item.visitInfoComment"
                              custom-error-msg=""
                              :disabled="item.saved || !canEditReposition"
                              :error="errors[0]"
                              :max-length="200"
                              :maxlength="200"
                              :rows="2"
                              :single-line="true"
                            />
                          </validation-provider>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab
                      :active="
                        item.selectedTab ==
                          additionalInfoTabs.INTERNAL_PRACTITIONER
                      "
                      title="Practicantes / Internos"
                    >
                      <div class="row">
                        <div class="col">
                          <div class="col border-right">
                            <div class="color-secondary-6">
                              Practicante / Interno:
                            </div>
                            <custom-drop-down
                              v-model="item.selectedPractitioner"
                              :disabled="item.saved"
                              fieldkey="id"
                              fieldname="name"
                              :options="internalPractitionerAvailable(item)"
                              placeholder="Seleccione"
                              @input="onChangePractitionerHandler(item, index)"
                            />
                          </div>
                        </div>
                        <div class="col">
                          <custom-chips-group
                            class="mt-n3"
                            :disabled="item.saved"
                            no-background
                            :no-wrap="true"
                            object-text="name"
                            :selected-items="item.practitionerSelected"
                            title="Practicante / Interno seleccionados"
                            @itemMarkedForDeletion="unSelectItem"
                          />
                        </div>
                      </div>
                    </b-tab>
                    <b-tab
                      v-if="enableReplaceSpecialist(item)"
                      :active="
                        item.selectedTab ==
                          additionalInfoTabs.REPLACE_SPECIALIST
                      "
                      title="Reemplazar Especialista / Lugar"
                    >
                      <div class="row mx-3">
                        <div class="col">
                          <checkbox
                            v-model="item.selectedSpecialistOption"
                            class="mb-2"
                            text="Especialista: "
                            @input="
                              onChangeSelectedSpecialist(
                                item.selectedSpecialistOption,
                                index
                              )
                            "
                          />
                          <custom-drop-down
                            v-model="item.selectedSpecialist"
                            :disabled="
                              (item.saved &&
                                !item.isReplaceSpecialistVisible) ||
                                !item.selectedSpecialistOption
                            "
                            fieldkey="id"
                            fieldname="name"
                            :options="specialistsReplacement"
                            placeholder="Seleccione"
                          />
                        </div>
                        <div class="col">
                          <div>
                            <checkbox
                              v-model="item.selectedPlaceOption"
                              class="mb-2"
                              text="Tipo de Lugar: "
                              @input="onChangeSelectedPlace(item, index)"
                            />
                          </div>
                          <div>
                            <custom-drop-down
                              v-model="item.selectedPlaceType"
                              :disabled="
                                (item.saved &&
                                  !item.isReplaceSpecialistVisible) ||
                                  !item.selectedPlaceOption
                              "
                              fieldkey="id"
                              fieldname="name"
                              :options="visitLocations"
                              placeholder="Seleccione"
                              @input="onChangePlaceType(item, index)"
                            />
                          </div>
                          <div
                            v-if="isLocationTypeEscuela(item.selectedPlaceType)"
                          >
                            <div v-if="item.selectedPlaceType" class="mt-3">
                              <div class="color-secondary-6">
                                Región:
                              </div>
                              <custom-drop-down
                                v-model="item.selectedRegion"
                                :disabled="
                                  (item.saved &&
                                    !item.isReplaceSpecialistVisible) ||
                                    !item.selectedPlaceOption
                                "
                                fieldkey="id"
                                fieldname="name"
                                :options="visitRegions"
                                placeholder="Seleccione"
                                @input="onChangeRegion(item, index)"
                              />
                            </div>
                            <div v-if="item.selectedPlaceType" class="mt-3">
                              <div class="color-secondary-6">
                                Distrito:
                              </div>
                              <custom-drop-down
                                v-model="item.selectedDistrict"
                                :disabled="
                                  (item.saved &&
                                    !item.isReplaceSpecialistVisible) ||
                                    !item.selectedPlaceOption
                                "
                                fieldkey="id"
                                fieldname="name"
                                :options="visitDistricts"
                                placeholder="Seleccione"
                                @input="onChangeDistrict(item, index)"
                              />
                            </div>
                            <div v-if="item.selectedPlaceType" class="mt-3">
                              <div class="color-secondary-6">
                                Escuela:
                              </div>
                              <custom-drop-down
                                v-model="item.selectedLocationService"
                                :disabled="
                                  (item.saved &&
                                    !item.isReplaceSpecialistVisible) ||
                                    !item.selectedPlaceOption
                                "
                                fieldkey="id"
                                fieldname="name"
                                :options="visitSchools"
                                placeholder="Seleccione"
                                @input="onChangeSchool(item)"
                              />
                            </div>
                          </div>

                          <div
                            v-if="isEnabledMunicipality(item.selectedPlaceType)"
                            class="mt-3"
                          >
                            <div class="color-secondary-6">
                              Municipio:
                            </div>
                            <custom-drop-down
                              v-model="item.selectedMunicipality"
                              :disabled="
                                (item.saved &&
                                  !item.isReplaceSpecialistVisible) ||
                                  !item.selectedPlaceOption
                              "
                              fieldkey="id"
                              fieldname="name"
                              :options="visitMunicipalities"
                              placeholder="Seleccione"
                              @input="onChangeMunicipality(item, index)"
                            />
                          </div>
                          <div
                            v-if="
                              isEnabledLocationService(item.selectedPlaceType)
                            "
                            class="mt-3"
                          >
                            <div class="color-secondary-6">
                              Lugar de Servicio:
                            </div>
                            <custom-drop-down
                              v-model="item.selectedLocationService"
                              :disabled="
                                (item.saved &&
                                  !item.isReplaceSpecialistVisible) ||
                                  !item.selectedPlaceOption
                              "
                              fieldkey="id"
                              fieldname="name"
                              :options="visitLocationServices"
                              placeholder="Seleccione"
                              @input="onChangeLocationService(item, index)"
                            />
                          </div>
                          <div
                            v-if="isEnabledCaat(item.selectedPlaceType)"
                            class="mt-3"
                          >
                            <div class="color-secondary-6">
                              CAAT:
                            </div>
                            <custom-drop-down
                              v-model="item.selectedLocationService"
                              :disabled="
                                (item.saved &&
                                  !item.isReplaceSpecialistVisible) ||
                                  !item.selectedPlaceOption
                              "
                              fieldkey="id"
                              fieldname="name"
                              :options="visitLocationServices"
                              placeholder="Seleccione"
                              @input="onChangeLocationService(item, index)"
                            />
                          </div>
                          <div
                            v-if="isEnabledCenter(item.selectedPlaceType)"
                            class="mt-3"
                          >
                            <div class="color-secondary-6">
                              Centro:
                            </div>
                            <custom-drop-down
                              v-model="item.selectedCenter"
                              :disabled="
                                (item.saved &&
                                  !item.isReplaceSpecialistVisible) ||
                                  !item.selectedPlaceOption
                              "
                              fieldkey="id"
                              fieldname="name"
                              :options="visitCenters"
                              placeholder="Seleccione"
                              @input="onChangeCenter(item, index)"
                            />
                          </div>
                        </div>
                      </div>
                    </b-tab>
                    <b-tab
                      v-if="requiresDocumentation(item)"
                      :active="item.selectedTab == additionalInfoTabs.DOCUMENTS"
                      title="Documentos"
                    >
                      <div class="row mx-4">
                        <div class="col">
                          <div class="color-secondary-6">
                            Tipo de Documento:
                          </div>
                          <custom-drop-down
                            v-model="item.documentType"
                            :disabled="item.saved"
                            fieldkey="id"
                            fieldname="name"
                            :options="documentTypes"
                            placeholder="Seleccione"
                          />
                        </div>
                        <div class="col">
                          <div class="color-secondary-6">
                            Archivo
                          </div>
                          <custom-file-input
                            ref="attachedDocument"
                            v-model="item.selectedDocument"
                            :accept="'.pdf'"
                            :attachment-id="item.documentId"
                            :disabled="item.saved"
                            display-style="normal"
                            label-position="left"
                            required
                            @after-remove="afterRemoveHandler(item, index)"
                            @input="
                              onChangeDocument(item.selectedDocument, index)
                            "
                          />
                        </div>
                      </div>
                    </b-tab>
                  </b-tabs>
                </div>
              </div>
            </template>
          </custom-callout>
          <div
            v-if="(item.errors || item.validations) && !isPeriodFinalized"
            class="visit-error-container"
          >
            <error
              v-for="(error, errorIndex) in item.validations"
              :key="`validation-container-visit` + errorIndex"
              :message="error"
              variant="no-border"
            />
            <error
              v-for="(error, errorIndex) in item.errors"
              :key="`error-container-visit` + errorIndex"
              :message="error"
              variant="no-border"
            />
          </div>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import { serialize as objectToFormData } from 'object-to-formdata';
import moment from 'moment';
import 'moment/locale/es-do';
import {
  CustomDropDown,
  ActionButton,
  CustomTextArea,
  CustomChipsGroup,
  CustomInput,
  Error,
} from '@/components/common';
import CustomCallout from 'custom-callout';
import CustomFileInput from '@/components/common/CustomFileInput';
import Checkbox from '@/shared/components/Checkbox/View';
import VisitTag from './VisitTag';
import visitTypes from '@/utils/constants/visitTypes.js';
import visitAbsenceTypes from '@/utils/constants/visitAbsenceRegistrationTypes.js';
import disciplineTypeCode from '@/utils/constants/disciplineTypeCode.js';
import _ from 'lodash';
import alertMixin from '@/mixins/alert.mixin.js';
import {
  ACTION_TYPES,
  MUTATION_TYPES,
} from '@/modules/visitRegistry/store/types';
import { name } from '@/modules/visitRegistry/store';
import { createNamespacedHelpers } from 'vuex';
import storeMixin from '@/shared/mixins/storeGenerator';
import visitRegistryService from '@/modules/visitRegistry/api';

const {
  mapState,
  mapGetters,
  mapActions,
  mapMutations,
} = createNamespacedHelpers(name);
import visitRegistryApi from '@/modules/visitRegistry/api.js';
import { validateIsActiveDayOfWeek as _validateIsActiveDayOfWeek } from '@/modules/shared/confRelatedServiceAcademicWeek.api';
import locationTypes from '@/utils/constants/locationTypes.js';
import visitTypeCategories from '@/utils/constants/visitTypeCategories.js';
import { getSysparameterByNames as _getSysparameterByNames } from '@/modules/shared/sysparameter.api';
import sysparameterByNames from '@/utils/constants/sysParameterNames';
import ConfRelatedAcademicWeekFlagTypes from '@/utils/shared/constants/confRelatedAcademicWeekFlagTypes';
import CompensatoryRequestTypes from '@/utils/constants/compensatoryRequestTypes';
import VisitAbsenceRegistrationTypes from '@/utils/constants/visitAbsenceRegistrationTypes.js';

export default {
  name: 'RegisterVisit',
  components: {
    CustomCallout,
    CustomInput,
    CustomDropDown,
    ActionButton,
    CustomTextArea,
    CustomChipsGroup,
    CustomFileInput,
    Error,
    Checkbox,
    VisitTag,
  },
  mixins: [alertMixin, storeMixin],
  props: {
    referralForVisits: {
      type: Array,
      default: () => [],
    },
    studentInfo: {
      type: Object,
      default: () => {},
    },
    isPeriodFinalized: {
      type: Boolean,
      default: () => false,
    },
    compensatoryInfo: {
      type: Object,
      default: () => {},
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    catalog: {
      timeOptions: [
        { value: 'am', text: 'AM' },
        { value: 'pm', text: 'PM' },
      ],
    },
    studentServiceIds: [],
    practitioners: [],
    previousAcademicYears: [],
    editVisitOriginalInfo: {},
    canEditReposition: true,
    previousCompensatories: [],
    filteredPreviousCompensatories: [],
    minimumAEEBlockDate: null,
    maximumAEEBlockDate: null,
    blockAEEFlag: null,
    visitTypesOptions: [],
  }),
  computed: {
    ...mapGetters({
      selectedPeriodFiltered: 'getFilteredPeriod',
      selectedVisitSearchFilter: 'getVisitFilter',
    }),
    ...mapState({
      documentTypes: (state) => state.catalog.documentTypes,
      visitAbsenceRegistrations: (state) =>
        state.catalog.visitAbsenceRegistration,
      replacements: (state) => state.catalog.replacements,
      repositions: (state) => state.catalog.repositions,
      specialistsReplacement: (state) => state.catalog.specialistsReplacement,
      visitLocations: (state) => state.catalog.visitLocations,
      visitRegions: (state) => state.catalog.visitRegions,
      visitDistricts: (state) => state.catalog.visitDistricts,
      visitSchools: (state) => state.catalog.visitSchools,
      visitsModel: (state) => state.visits,
      visitMunicipalities: (state) => state.catalog.visitMunicipalities,
      visitLocationServices: (state) => state.catalog.visitLocationServices,
      visitCenters: (state) => state.catalog.visitCenters,
    }),
    selectedPeriod() {
      return this.selectedPeriodFiltered.monthNumber
        ? this.selectedPeriodFiltered
        : this.$route.params.currentPeriod ||
            this.$route.params.initialPeriodInfo;
    },
    isLocationTypeEscuela() {
      return (item) => item?.id == locationTypes.Escuela;
    },
    filteredAbsences() {
      let notValidAbsences = [];
      switch (this.$route.params.locationTypeId) {
        case locationTypes.OfficinaProveedor:
          notValidAbsences.push(
            VisitAbsenceRegistrationTypes.CambiosProgramacionEscolar
          );
          break;
      }
      return this.visitAbsenceRegistrations.filter(
        (v) => !notValidAbsences.includes(v.id)
      );
    },
    canDeletePlanVisits() {
      return this.userHasPermissions('visits.candeleteplanvisits');
    },
    isEnabledMunicipality() {
      return (item) =>
        [
          locationTypes.OfficinaProveedor,
          locationTypes.CSEE,
          locationTypes.CAAT,
          locationTypes.Hogar,
        ].includes(item?.id);
    },
    isEnabledLocationService() {
      return (item) => [locationTypes.OfficinaProveedor].includes(item?.id);
    },
    isEnabledCaat() {
      return (item) => [locationTypes.CAAT].includes(item?.id);
    },
    isEnabledCenter() {
      return (item) => [locationTypes.CSEE].includes(item?.id);
    },
    isLocationTypeMunicipio() {
      return (item) => item?.id == locationTypes.Municipio;
    },
    canShowEditVisit() {
      return (item) =>
        item?.selectedType?.id != visitTypes.Visita_Paquete_Plan &&
        item?.selectedType?.id != visitTypes.Visita_Plan &&
        item?.selectedType?.id != visitTypes.Visita_Admision;
    },
    canShowDeleteVisit() {
      const visits = [
        visitTypes.Visita_Paquete_Plan,
        visitTypes.Visita_Plan,
        visitTypes.Visita_Admision,
      ];
      return (item) =>
        visits.includes(item?.selectedType?.id)
          ? this.canDeletePlanVisits
          : true;
    },
    additionalInfoTabs() {
      return {
        VISIT_ADDITIONAL_INFO: 1,
        INTERNAL_PRACTITIONER: 2,
        REPLACE_SPECIALIST: 3,
        DOCUMENTS: 4,
      };
    },
    toggleClass() {
      return (isOpen) => ({
        'far fa-chevron-circle-right orange-color': !isOpen,
        'far fa-chevron-circle-down green-color': isOpen,
      });
    },
    visits: {
      get() {
        return this.visitsModel;
      },
      set(value) {
        this[MUTATION_TYPES.SET_VISITS](value);
      },
    },
    getHourRange() {
      return (item) => {
        return (
          moment(
            `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
            'hh:mm A'
          )
            .format('h:mm A')
            .toLowerCase() +
          ' - ' +
          moment(item.hourEnd, 'hh:mm A')
            .format('h:mm A')
            .toLowerCase()
        );
      };
    },
    enableActionButton() {
      return (item) =>
        (!item.saved && !this.isPeriodFinalized) ||
        item.enableReplaceSpecialist;
    },
    enableActionMenu() {
      return (item) => item.saved || item.enableReplaceSpecialist;
    },
    enableJustification() {
      return (item) => item?.id == visitTypes.Ausencia;
    },
    enableRepositionDate() {
      return (item) =>
        item?.id == visitTypes.VisitaReposicion ||
        item?.id == visitTypes.Ausencia_Ofrecimiento ||
        item?.id == visitTypes.Ciberterapia_Reposicion_Ano_Actual ||
        item?.id == visitTypes.Visita_Presencial_Reposicion_Ano_Actual_Covid19;
    },
    enableReplaceSpecialist() {
      return (item) => (item.enableReplaceSpecialist ? true : false);
    },
    hideVisitAdditionalInformation() {
      return (item) =>
        [
          visitTypes.VisitaRegular,
          visitTypes.VisitaReposicion_AnoAnterior,
          visitTypes.Ausencia_Ofrecimiento_AnoAnterior,
        ].includes(item?.id)
          ? false
          : true;
    },
    enableComment() {
      return (item) =>
        [
          visitTypes.VisitaRegular,
          visitTypes.VisitaReposicion_AnoAnterior,
          visitTypes.VisitaReposicion,
          visitTypes.Ciberterapia_Reposicion_Ano_Actual,
          visitTypes.Visita_Presencial_Reposicion_Ano_Actual_Covid19,
          visitTypes.Ausencia_Ofrecimiento_AnoAnterior,
        ].includes(item?.id)
          ? false
          : true;
    },
    requiresDocumentation() {
      return (item) =>
        [visitAbsenceTypes.AusenciaJustificadaDelEstudiante].includes(
          item.selectedVisitInfoJustification?.id
        )
          ? true
          : false;
    },
    internalPractitionerAvailable() {
      return (item) => {
        return _.differenceBy(
          this.practitioners,
          item.practitionerSelected,
          'id'
        );
      };
    },
    getItemName() {
      return (item) => {
        return item?.id ? item.name : '';
      };
    },
    validateSelectedVisitInfoJustification() {
      return (item) => {
        return (
          item.selectedVisitInfoJustification != null &&
          item.selectedVisitInfoJustification.id &&
          item.saved
        );
      };
    },
    showHasta() {
      return (
        this.referralForVisits[0].disciplineTypeId == disciplineTypeCode.ABA ||
        this.referralForVisits[0].disciplineTypeId ==
          disciplineTypeCode.ProgramaABA
      );
    },
    getCommentRule() {
      return (item) => {
        return item.visitTypeCategorieId == visitTypeCategories.Ausencia &&
          item.selectedTab != this.additionalInfoTabs.REPLACE_SPECIALIST
          ? 'required'
          : '';
      };
    },
    isRepositionVisitType() {
      return (selectedVisitTypeId) => {
        const repositionVisitTypes = [
          visitTypes.Ausencia_Ofrecimiento_Reposicion_Ano_Anterior,
          visitTypes.Ciberterapia_Reposicion_Ano_Actual,
          visitTypes.Ciberterapia_Reposicion_Ano_Anterior,
          visitTypes.VisitaReposicion,
          visitTypes.VisitaReposicion_AnoAnterior,
        ];
        return repositionVisitTypes.includes(selectedVisitTypeId);
      };
    },
    isCompensatoryRepositionVisitType() {
      return (selectedVisitTypeId) => {
        const repositionVisitTypes = [
          visitTypes.Ausencia_Especialista,
          visitTypes.Ausencia_Ofrecimiento_Reposicion,
          visitTypes.Presencial_Reposicion,
          visitTypes.Telepractica_Reposicion,
        ];
        return repositionVisitTypes.includes(selectedVisitTypeId);
      };
    },
    isCompensatoryRegresionVisitType() {
      return (selectedVisitTypeId) => {
        const regressionVisitTypes = [
          visitTypes.Ausencia_Especialista,
          visitTypes.Ausencia_Ofrecimiento_Regresion,
          visitTypes.Compensatorio_Reposicion_Ausencia,
          visitTypes.Compensatorio_Regresion,
          visitTypes.Presencial_Regresion,
          visitTypes.Telepractica_Regresion,
        ];
        return regressionVisitTypes.includes(selectedVisitTypeId);
      };
    },
  },
  watch: {
    referralForVisits: {
      handler(newValue) {
        if (newValue) {
          this.studentServiceIds = newValue.map((item) => {
            return item.visitStudentServiceId;
          });
          this.getVisitList();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  async mounted() {
    this[ACTION_TYPES.GET_DOCUMENT_TYPES]();
    this[ACTION_TYPES.GET_VISIT_ABSENCE_REGISTRATION]();
    await this.getSysParameters();
  },
  methods: {
    ...mapActions([
      ACTION_TYPES.GET_VISIT_TYPES,
      ACTION_TYPES.GET_DOCUMENT_TYPES,
      ACTION_TYPES.GET_PRACTITIONER,
      ACTION_TYPES.GET_VISIT_ABSENCE_REGISTRATION,
      ACTION_TYPES.SAVE_VISIT,
      ACTION_TYPES.DELETE_VISIT,
      ACTION_TYPES.GET_VISIT_VALID_REPLACEMENT,
      ACTION_TYPES.GET_VISIT_VALID_REPOSITION,
      ACTION_TYPES.GET_SPECIALIST_REPLACEMENT,
      ACTION_TYPES.GET_VISITS,
      ACTION_TYPES.GET_VISIT_LOCATION,
      ACTION_TYPES.GET_VISIT_REGION,
      ACTION_TYPES.GET_VISIT_DISTRICT,
      ACTION_TYPES.GET_VISIT_SCHOOL,
      ACTION_TYPES.GET_VISIT_MUNICIPALITIES,
      ACTION_TYPES.GET_VISIT_CENTERS,
      ACTION_TYPES.GET_VISIT_LOCATION_SERVICES,
    ]),
    ...mapMutations([
      MUTATION_TYPES.SET_VISITS,
      MUTATION_TYPES.SET_VISIT_ENTRY,
      MUTATION_TYPES.SET_CLEAR_CATALOG,
    ]),
    // filterVisitTypes(types) {
    //   const nonValidVisitTypes = [
    //     visitTypes.VisitaRegular,
    //     visitTypes.Ausencia,
    //     visitTypes.Visita_Ciberterapia,
    //   ];
    //
    //   return types;
    // },
    async getSysParameters() {
      const { data: sysParameters } = await _getSysparameterByNames({
        parameterNames: [
          sysparameterByNames.ExtendedAcademicYear,
          sysparameterByNames.LastSchoolDate,
          sysparameterByNames.BlockRegularVisitsRegistryDuringAEE,
        ],
        academicYearId: this.studentInfo.academicYearId,
      });
      this.minimumAEEBlockDate = new Date(
        sysParameters.find(
          (x) => x.name === sysparameterByNames.LastSchoolDate
        ).staticValue
      );
      this.maximumAEEBlockDate = new Date(
        sysParameters.find(
          (x) => x.name === sysparameterByNames.ExtendedAcademicYear
        ).rangeMinimumValue
      );
      this.blockAEEFlag = Boolean(
        sysParameters.find(
          (x) =>
            x.name === sysparameterByNames.BlockRegularVisitsRegistryDuringAEE
        ).staticValue
      );
    },
    async onPreviousAcademicYearChanged(item) {
      const previousAcademicYearIdSelected = item?.previousAcademicYear?.id;
      if (previousAcademicYearIdSelected > 0) {
        this.filteredPreviousCompensatories = this.previousCompensatories.filter(
          (x) => x.academicYearId == previousAcademicYearIdSelected
        );
        if (
          this.filteredPreviousCompensatories.findIndex(
            (x) => x.id === item?.compensatoryRequestSelected?.id
          ) === -1
        ) {
          item.compensatoryRequestSelected = null;
        }
      } else {
        this.filteredPreviousCompensatories = [];
        item.compensatoryRequestSelected = null;
      }
    },
    async onChangePlaceType(item, index) {
      this.updateVisitEntry(index, {
        selectedRegion: null,
        selectedDistrict: null,
        selectedMunicipality: null,
        selectedCenter: null,
        selectedLocationService: null,
      });
      if (item?.selectedPlaceType?.id) {
        if (item?.selectedPlaceType?.id == locationTypes.Escuela) {
          await this.callGetVisitRegion();
        }
        if (
          [
            locationTypes.CSEE,
            locationTypes.OfficinaProveedor,
            locationTypes.CAAT,
            locationTypes.Hogar,
          ].includes(item?.selectedPlaceType?.id)
        ) {
          await this.callGetMunicipality(item);
        }
      }

      //clear descendants values
      this.clearCatalogValues({
        visitLocationServices: [],
        visitDistricts: [],
        visitSchools: [],
      });
    },
    onChangeRegion(item, index) {
      this.updateVisitEntry(index, {
        selectedDistrict: null,
        selectedLocationService: null,
      });
      if (item?.selectedRegion?.id) {
        this.callGetVisitDistrict(item?.selectedRegion?.id);
      }

      this.clearCatalogValues({
        visitSchools: [],
      });
    },
    onChangeDistrict(item, index) {
      this.updateVisitEntry(index, {
        selectedLocationService: null,
      });
      if (item?.selectedDistrict?.id) {
        this.callGetVisitSchool(
          item?.selectedRegion?.id,
          item?.selectedDistrict?.id
        );
      }
    },
    onChangeSchool() {},
    onChangeMunicipality(item, index) {
      this.updateVisitEntry(index, {
        selectedCenter: null,
        selectedLocationService: null,
      });
      if (item?.selectedMunicipality?.id) {
        if (
          [locationTypes.OfficinaProveedor, locationTypes.CAAT].includes(
            item.selectedPlaceType?.id
          )
        ) {
          this.callGetLocationServices(item);
        }
        if (item.selectedPlaceType?.id === locationTypes.CSEE) {
          this.callGetCenter(item?.selectedMunicipality?.id);
        }
      }
    },
    onChangeLocationService() {},
    onChangeCenter() {},
    onToggleAdditionalInfo(item, itemIndex) {
      this.visits = {
        ...this.visits,
        data: this.visits.data.map((s, index) => {
          if (index === itemIndex) {
            s.isOpen = !s.isOpen;
          } else {
            s.isOpen = false;
          }
          return s;
        }),
      };
    },
    onChangeSelectedSpecialist(value, index) {
      if (value == false) {
        this.updateVisitEntry(index, {
          selectedSpecialist: null,
        });
      }
    },
    onChangeSelectedPlace(item, index) {
      if (item.selectedPlaceOption == false) {
        this.updateVisitEntry(index, {
          selectedMunicipality: null,
          selectedCenter: null,
          selectedLocationService: null,
          selectedSchool: null,
          selectedDistrict: null,
          selectedRegion: null,
          selectedPlaceType: null,
        });
      }
    },
    onCancelEdit(item, itemIndex) {
      if (item.id) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s, index) => {
            if (index === itemIndex) {
              s.saved = true;
              s.isOpen = false;
              s.enableReplaceSpecialist = false;
              s.isReplaceSpecialistVisible = false;
              s.selectedSpecialistOption = false;
              s.selectedPlaceOption = false;
              s.previousAcademicYear = this.editVisitOriginalInfo.previousAcademicYear;
              s.day = this.editVisitOriginalInfo.day;
              s.hourStartHour = this.editVisitOriginalInfo.hourStartHour;
              s.hourStartMinute = this.editVisitOriginalInfo.hourStartMinute;
              s.hourStartTime = this.editVisitOriginalInfo.hourStartTime;
              s.hourEnd = this.editVisitOriginalInfo.hourEnd;
              s.selectedPlaceType = this.editVisitOriginalInfo.selectedPlaceType;
              s.selectedRegion = this.editVisitOriginalInfo.selectedRegion;
              s.selectedDistrict = this.editVisitOriginalInfo.selectedDistrict;
              s.selectedSchool = this.editVisitOriginalInfo.selectedSchool;
              s.selectedMunicipality = this.editVisitOriginalInfo.selectedMunicipality;
              s.selectedCenter = this.editVisitOriginalInfo.selectedCenter;
              s.selectedLocationService = this.editVisitOriginalInfo.selectedLocationService;
              s.selectedSpecialist = this.editVisitOriginalInfo.selectedSpecialist;
              s.selectedType = this.editVisitOriginalInfo.selectedType;
            } else {
              s.isOpen = false;
            }
            return s;
          }),
        };
      }
    },
    async handleSaveVisit(item, saveEdit, index) {
      const isValid = await this.$refs.registerVisitForm[index].validate();
      const _validations = await this.validateVisitEntry(item, index);

      if (!isValid || _validations.length > 0) {
        this.updateVisitEntry(index, { validations: _validations });
        this.ShowToast('Error', 'Favor llenar los campos requeridos.', 'error');
        return;
      }

      //El slice se usa para quitar el timezone del user.
      const visitDate = moment([
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        item.day,
      ])
        .format()
        .slice(0, -6);

      const selectedVisitTypeId = item?.selectedType?.id || 0;

      if (
        (this.compensatoryInfo?.requestTypeId ===
          CompensatoryRequestTypes.Reposicion &&
          this.isCompensatoryRepositionVisitType(selectedVisitTypeId)) ||
        (this.compensatoryInfo?.requestTypeId ===
          CompensatoryRequestTypes.Regresion &&
          this.isCompensatoryRegresionVisitType(selectedVisitTypeId)) ||
        this.isRepositionVisitType(selectedVisitTypeId)
      ) {
        const payload = {
          entryDate: visitDate,
          flagType: ConfRelatedAcademicWeekFlagTypes.RepositionFlag,
        };
        const { data: isActiveDayOfWeek } = await _validateIsActiveDayOfWeek(
          payload
        );
        if (!isActiveDayOfWeek) {
          this.ShowToast('Atención', 'Dia de visita no es lectivo', 'error');
          return;
        }
      }

      this.updateVisitEntry(index, { validations: null });

      const timeStartFull = moment([
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        item.day,
        this.parseHour(item.hourStartTime, item.hourStartHour),
        item.hourStartMinute,
      ])
        .format()
        .slice(0, -6);

      const computedVersion =
        !this.showHasta ||
        (this.showHasta &&
          item.selectedTab == this.additionalInfoTabs.REPLACE_SPECIALIST);

      const calculatedEndHour = !computedVersion
        ? item.hourEnd
        : item.hourEnd.substring(0, 2);

      const hourEndTime = !computedVersion
        ? item.hourEndTime
        : item.hourEnd.substring(6, 8);

      const calculatedEndMinutes = !computedVersion
        ? item.hourEndMinute
        : item.hourEnd.substring(3, 5);

      const timeEndFull = moment([
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        item.day,
        this.parseHour(hourEndTime, calculatedEndHour),
        calculatedEndMinutes,
      ])
        .format()
        .slice(0, -6);

      const visitAbsenceReasonId = [visitTypes.Ausencia].includes(
        item.selectedType?.id
      )
        ? item.selectedVisitInfoJustification?.id
        : null;

      const dataToSend = {
        visitId: item.id ?? null,
        studentSieId: this.studentInfo.studentSieId,
        timeStart: timeStartFull,
        timeEnd: timeEndFull,
        date: visitDate,
        academicYearId: this.studentInfo.academicYearId,
        visitTypeId: item.selectedType?.id ?? null,
        admissionId: this.studentInfo.admissionId ?? null,
        durationId: this.studentInfo.durationId ?? null,
        modalityId: this.studentInfo.modalityId ?? null,
        locationTypeId: item.id
          ? item.selectedPlaceType?.id ?? null
          : this.studentInfo?.locationTypeId,
        centerId: this.studentInfo.centerId,
        companyId: this.studentInfo.companyId,
        practioners: item.practitionerSelected ?? null,
        comment: item.visitInfoComment,
        compensatoryRequestTypeId: this.compensatoryInfo?.requestTypeId || 0,
        visitAbsenceReasonId: visitAbsenceReasonId,
        replacementVisitId: item.selectedVisitInfoDateReposition?.id ?? null,
        documentTypeId: item.documentType?.id ?? null,
        serviceSpecialistId: this.compensatoryInfo
          ? this.compensatoryInfo.serviceSpecialistId
          : this.selectedVisitSearchFilter.specialist?.id ?? null,
        specialistId: item.selectedSpecialist?.id ?? null,
        file: item.selectedDocument,
        isDocumentRemoved: item.isDocumentRemoved,
        previousAcademicYearId: item.previousAcademicYear?.id,
        CompensatoryRequestIdSelected:
          item.compensatoryRequestSelected?.id ??
          item.compensatoryRequestSelected?.compensatoryRequestId,
        requestNumber: this.compensatoryInfo?.requestNumber ?? null,
        studentSpecialistId: this.studentInfo.specialistId,
        schoolTypeId: this.studentInfo.schoolTypeId,
        locationFiscalYearId:
          item.selectedLocationService?.id ??
          this.studentInfo?.locationFiscalYearId,
      };

      //set disciplineTypeId
      dataToSend.disciplineTypeId = this.studentInfo.disciplineTypeId;

      //set fulltime prop
      this.updateVisitEntry(index, { timeStartFull, timeEndFull });

      let formData = objectToFormData(dataToSend, {
        indices: true,
        nullsAsUndefineds: true,
      });

      await this[ACTION_TYPES.SAVE_VISIT]({
        formData,
        itemIndex: index,
        id: item.id,
      })
        .then(() => {
          this.ShowToast(
            'Proceso exitoso.',
            'Sus datos han sido guardados exitosamente.',
            'success'
          );
        })
        .catch((error) => {
          let errorMessage =
            error.response && error.response.data
              ? error.response.data.message
              : 'ha ocurrido un error inesperado.';
          this.ShowToast('Error', errorMessage, 'error');
        });

      await this.getVisitList();
      await this.updateVisitEntry(index, { isOpen: false });
    },
    getPeriodDate() {
      return moment()
        .year(this.selectedPeriod.year)
        .month(this.selectedPeriod.monthNumber - 1)
        .date(1)
        .toDate();
    },
    async haveReplacementVisit(id) {
      const { data: result } = visitRegistryApi.haveReplacementVisit(id);
      return result;
    },
    async getVisitList() {
      await this[ACTION_TYPES.GET_VISITS]({
        studentServiceIds: this.studentServiceIds,
        month: parseInt(this.selectedPeriod.monthNumber),
        periodAcademicYear: moment()
          .date(1)
          .month(this.selectedPeriod.monthNumber - 1)
          .year(this.selectedPeriod.year)
          .toDate(),
        compensatoryRequestType: this.compensatoryInfo?.requestTypeId ?? null,
        companyId: this.studentInfo.companyId,
      });
    },
    getReplacementDates() {
      this[ACTION_TYPES.GET_VISIT_VALID_REPLACEMENT]({
        academicYearId: this.studentInfo.academicYearId,
        studentServiceId: this.studentInfo.visitStudentServiceId,
      });
    },
    getRepositionDates() {
      this[ACTION_TYPES.GET_VISIT_VALID_REPOSITION]({
        academicYearId: this.studentInfo.academicYearId,
        studentServiceId: this.studentInfo.visitStudentServiceId,
      });
    },
    async getPractitionerList(item) {
      const visitDate = moment()
        .year(this.selectedPeriod.year)
        .month(this.selectedPeriod.monthNumber - 1)
        .date(item.day)
        .toDate();

      const specialistId = item.selectedSpecialist?.id
        ? item.selectedSpecialist.id
        : this.studentInfo.specialistId;
      await visitRegistryService
        .getPractitionerFromSpecialistId(
          specialistId,
          this.studentInfo.disciplineTypeId,
          visitDate
        )
        .then((res) => {
          this.practitioners = res.data;
        });
    },
    async getPreviousAcademicYearsAndCompensatories() {
      await visitRegistryApi
        .getPreviousYearAndCompensatoryIdsForRegisterVisit(
          this.studentInfo.studentSieId,
          this.studentInfo.disciplineTypeId
        )
        .then(({ data: res }) => {
          res.years.map((a) => {
            a.name = a.description;
          });
          this.previousAcademicYears = res.years;
          this.previousCompensatories = res.compensatories;
          this.filteredPreviousCompensatories = res.compensatories;
        })
        .catch(() => {});
    },
    async getSpecialistReplacementList() {
      this[ACTION_TYPES.GET_SPECIALIST_REPLACEMENT]({
        academicYearId: this.studentInfo.academicYearId,
        companyId: this.studentInfo.companyId,
        disciplineId: this.studentInfo.disciplineTypeId,
        admissionId: this.studentInfo.admissionId,
        visitDate: this.editVisitOriginalInfo.date,
      });
    },
    async callGetVisitLocationTypes() {
      this[ACTION_TYPES.GET_VISIT_LOCATION]();
    },
    async callGetVisitRegion() {
      this[ACTION_TYPES.GET_VISIT_REGION]({
        academicYearId: this.studentInfo.academicYearId,
        companyId: this.studentInfo.companyId,
      });
    },
    async callGetVisitDistrict(regionId) {
      this[ACTION_TYPES.GET_VISIT_DISTRICT]({
        academicYearId: this.studentInfo.academicYearId,
        regionId,
        companyId: this.studentInfo.companyId,
      });
    },
    async callGetVisitSchool(regionId, districtId) {
      this[ACTION_TYPES.GET_VISIT_SCHOOL]({
        academicYearId: this.studentInfo.academicYearId,
        regionId,
        districtId,
        companyId: this.studentInfo.companyId,
      });
    },
    async callGetMunicipality(item) {
      this[ACTION_TYPES.GET_VISIT_MUNICIPALITIES]({
        academicYearId: this.studentInfo.academicYearId,
        locationTypeId: item.selectedPlaceType?.id,
        companyId: this.studentInfo.companyId,
      });
    },
    async callGetCenter(municipalityId) {
      this[ACTION_TYPES.GET_VISIT_CENTERS]({
        academicYearId: this.studentInfo.academicYearId,
        municipalityId,
        companyId: this.studentInfo.companyId,
      });
    },
    async callGetLocationServices(item) {
      if (item.selectedPlaceType?.id === locationTypes.CAAT) {
        this[ACTION_TYPES.GET_VISIT_LOCATION_SERVICES]({
          academicYearId: this.studentInfo.academicYearId,
          locationTypeId: locationTypes.CAAT,
          municipalityId: item?.selectedMunicipality?.id,
          companyId: this.studentInfo.companyId,
        });
      } else {
        this[ACTION_TYPES.GET_VISIT_LOCATION_SERVICES]({
          academicYearId: this.studentInfo.academicYearId,
          locationTypeId: item.selectedPlaceType?.id,
          municipalityId: item?.selectedMunicipality?.id,
          companyId: this.studentInfo.companyId,
        });
      }
    },
    onChangeVisitType(item, itemIndex) {
      const selectedTypeId = item.selectedType?.id;
      this.canEditReposition = true;
      if (
        item.selectedType &&
        item.selectedType.showPreviousYears &&
        //To avoid multiple calls, i guess it should be called once, to emulate the call on mounted process.
        this.previousAcademicYears.length == 0 &&
        this.previousCompensatories.length == 0
      ) {
        this.getPreviousAcademicYearsAndCompensatories();
      }
      if (selectedTypeId) {
        if (
          [
            visitTypes.Ausencia,
            visitTypes.VisitaReposicion,
            visitTypes.Ausencia_Ofrecimiento,
            visitTypes.Ciberterapia_Reposicion_Ano_Actual,
            visitTypes.Visita_Presencial_Reposicion_Ano_Actual_Covid19,
          ].includes(selectedTypeId)
        ) {
          if (
            selectedTypeId === visitTypes.VisitaReposicion ||
            selectedTypeId === visitTypes.Ausencia_Ofrecimiento ||
            selectedTypeId === visitTypes.Ciberterapia_Reposicion_Ano_Actual ||
            selectedTypeId ==
              visitTypes.Visita_Presencial_Reposicion_Ano_Actual_Covid19
          ) {
            this.getRepositionDates();
          }
          this.updateVisitEntry(itemIndex, {
            isOpen: true,
            selectedTab: this.additionalInfoTabs.VISIT_ADDITIONAL_INFO,
            selectedVisitInfoJustification: null,
          });
          return;
        }
        this.updateVisitEntry(itemIndex, {
          isOpen: false,
        });
      }
    },
    onChangePractitionerHandler(item, itemIndex) {
      if (item.selectedPractitioner?.id) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s, index) => {
            if (index === itemIndex) {
              if (!Array.isArray(s.practitionerSelected)) {
                s.practitionerSelected = [];
              }
              s.practitionerSelected = [
                ...s.practitionerSelected,
                item.selectedPractitioner,
              ];
              s.selectedPractitioner = null;
            }
            return s;
          }),
        };
      }
    },
    clearCatalogValues(values) {
      this[MUTATION_TYPES.SET_CLEAR_CATALOG](values);
    },
    onChangeDocument(selectedDocument, itemIndex) {
      if (selectedDocument) {
        this.updateVisitEntry(itemIndex, {
          isDocumentRemoved: null,
        });
      }
    },
    unSelectItem(item) {
      if (item) {
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s) => {
            if (s.isOpen) {
              s.practitionerSelected = s.practitionerSelected.filter(
                (pItem) => {
                  return pItem.id != item.id;
                }
              );
            }
            return s;
          }),
        };
      }
    },
    async editVisit(item, itemIndex) {
      if (item?.id) {
        item.hourEndMinute = item.hourEnd.substring(3, 5);
        item.hourEndTime = item.hourEnd.substring(6, 8);

        await this.getPractitionerList(item);
        if (item.selectedType.showPreviousYears)
          await this.getPreviousAcademicYearsAndCompensatories();
        this.editVisitOriginalInfo = { ...item };
        this.visits = {
          ...this.visits,
          data: this.visits.data.map((s, index) => {
            if (index === itemIndex) {
              s.saved = false;
              s.isOpen = true;
              if (this.enableRepositionDate) {
                this.canEditReposition = false;
              }
            } else {
              if (s.id) {
                s.saved = true;
                s.isOpen = false;
                s.enableReplaceSpecialist = false;
                s.isReplaceSpecialistVisible = false;
              }
            }
            return s;
          }),
        };
      }
    },
    async onDeleteVisit(id, index) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar la visita documentada?',
        'Sí',
        'No'
      );
      if (answer) {
        await this[ACTION_TYPES.DELETE_VISIT]({ id, index })
          .then(() => {
            this.ShowToast(
              'Proceso Exitoso',
              'La información fue actualizada exitosamente.',
              'success'
            );
          })
          .catch((error) => {
            this.ShowToast('', error.response.data.message, 'error');
          });
        this.getVisitList();
      }
    },
    async replaceServicePlace(item, index) {
      this.editVisitOriginalInfo = { ...item };
      await this.getSpecialistReplacementList();
      await this.callGetVisitLocationTypes();

      //call descendants
      if (
        [
          locationTypes.OfficinaProveedor,
          locationTypes.CAAT,
          locationTypes.Hogar,
        ].includes(item.selectedPlaceType?.id)
      ) {
        await this.callGetMunicipality(item);
      }
      if (item.selectedPlaceType?.id == locationTypes.Escuela) {
        await this.callGetVisitRegion();
      }

      //do toggle
      this.visits = {
        ...this.visits,
        data: this.visits.data.map((mItem, mIndex) => {
          if (mIndex == index) {
            mItem.isOpen = true;
            (mItem.enableReplaceSpecialist = true),
              (mItem.selectedTab = this.additionalInfoTabs.REPLACE_SPECIALIST),
              (mItem.isReplaceSpecialistVisible = true);
          } else {
            if (mItem.id) {
              mItem.saved = true;
              mItem.isOpen = false;
              mItem.enableReplaceSpecialist = false;
              mItem.isReplaceSpecialistVisible = false;
            }
          }
          return mItem;
        }),
      };
    },
    async validateVisitEntry(item) {
      const validations = [];
      if (!item.day) {
        validations.push('Favor de entrar el día de la visita.');
      }
      if (!item.hourStartHour || !item.hourStartMinute) {
        validations.push('Favor de entrar la hora de comienzo de la visita.');
      }
      if (
        item.visitTypeCategorieId == visitTypeCategories.Ausencia &&
        !item.visitInfoComment &&
        item.selectedTab != this.additionalInfoTabs.REPLACE_SPECIALIST
      ) {
        validations.push(
          'Favor de entrar el comentario en el tab Información Adicional de Visitas.'
        );
      }
      if (
        this.showHasta &&
        (!item.hourEnd || !item.hourEndMinute) &&
        !item.saved
      ) {
        validations.push('Favor de entrar la hora de fin de la visita.');
      }
      if (!item.selectedType?.id) {
        validations.push('Favor de seleccionar el tipo de visita.');
      }

      if (
        item.selectedType &&
        item.selectedType.showPreviousYears &&
        !item.previousAcademicYear?.id
      ) {
        validations.push('Favor de seleccionar el año académico anterior.');
      }

      if (item.selectedType?.id) {
        //justification
        if ([visitTypes.Ausencia].includes(item.selectedType?.id)) {
          if (!item.selectedVisitInfoJustification?.id) {
            validations.push('Favor de seleccionar la justificación.');
          }
        }

        //comment
        if (
          [visitTypes.Ausencia, visitTypes.Ausencia_Ofrecimiento].includes(
            item.selectedType?.id
          )
        ) {
          if (!item.visitInfoComment) {
            validations.push('Favor de entrar el comentario.');
          }
        }

        //reposition date
        if (
          [
            visitTypes.Ausencia_Ofrecimiento,
            visitTypes.VisitaReposicion,
            visitTypes.Ciberterapia_Reposicion_Ano_Actual,
            visitTypes.Visita_Presencial_Reposicion_Ano_Actual_Covid19,
          ].includes(item.selectedType?.id)
        ) {
          if (!item.selectedVisitInfoDateReposition) {
            validations.push('Favor de seleccionar la fecha a reponer.');
          }
        }
      }

      if (item.day && item.hourStartHour && item.hourStartMinute) {
        let visitDate = this.getVisitDate(item.day);
        const { _hasDayValidRange, minimum, maximum } = this.hasDayValidRange(
          item.day
        );

        const _hasNoReferral = this.visitDayHasNoReferralValidation(item.day);

        const validForFuture = [
          visitTypes.Ausencia_Ofrecimiento,
          visitTypes.Ausencia,
        ].includes(item.selectedType?.id);

        const _visitDayIsFuture = validForFuture
          ? false
          : this.visitDayIsFuture(item.day);

        const _hourIsValid = this.isHourValid(item);
        const hourEnd = this.showHasta
          ? `${item.hourEnd}:${item.hourEndMinute}`
          : item.hourEnd;
        const _hourEndOverLimit = this.isHourEndOverLimit(hourEnd);
        const _isValidHourEnd = item.hourEnd
          ? this.isValidHourEnd(
              `${item.hourStartHour}:${item.hourStartMinute} ${item.hourStartTime}`,
              `${item.hourEnd}:${item.hourEndMinute} ${item.hourEndTime}`
            )
          : true;

        if (!_hasDayValidRange) {
          validations.push(
            `El día de la visita debe ser entre ${minimum} al ${maximum}.`
          );
        }
        if (!_hasNoReferral) {
          validations.push(
            'No se identificó vigencia de servicio para el día de visita.'
          );
        }
        if (_visitDayIsFuture) {
          validations.push('El día de la visita no puede ser al futuro.');
        }
        if (!_hourIsValid) {
          validations.push('La hora no es válida');
        }
        if (_hasNoReferral && _hourEndOverLimit) {
          validations.push(
            'El horario de la visita sobrepasa el límite permitido (7:00am a 8:00pm).'
          );
        }

        if (!_isValidHourEnd) {
          validations.push('La hora hasta debe ser mayor a la hora desde.');
        }

        if (!item.saved) {
          const _exceedDayMinutes = await this.exceedDayMinutes(
            this.studentInfo.admissionId,
            visitDate,
            item
          );

          if (_exceedDayMinutes) {
            validations.push(
              'Visita sobrepasa el límite según la duración del referido.'
            );
          }
        }
      }
      return validations;
    },
    hasDayValidRange(day) {
      const minimum = 1;
      const maximum = 31;
      return {
        _hasDayValidRange: _.inRange(parseInt(day), minimum, maximum + 1),
        minimum,
        maximum,
      };
    },
    isHourValid(item) {
      const _values = this.getEntryValues(item);

      const hour = parseInt(_values.hour, 10);
      const min = _values.min;
      const ampm = _values.ampm;

      const visitHour = moment(`${hour}:${min} ${ampm}`, 'h:mm A', true);

      return visitHour.isValid();
    },
    isHourEndOverLimit(hour) {
      const from = moment(hour, 'hh:mm A');
      const to = moment('8:00 PM', 'hh:mm A');
      return from.isAfter(to);
    },

    isValidHourEnd(startHour, endHour) {
      const from = moment(startHour, 'hh:mm A');
      const to = moment(endHour, 'hh:mm A');
      return to.isAfter(from) && !to.isSame(from);
    },
    visitDayHasNoReferralValidation(day) {
      var visitDate = this.getVisitDate(day);
      var referrals = this.lookUpVisitDayReferrals(visitDate);
      return !(referrals == null || referrals.length < 1);
    },
    visitDayIsFuture(day) {
      let visitDate = this.getVisitDate(day);
      let currentDate = new Date();
      return visitDate > currentDate;
    },
    async updateVisitEntry(entryIndex, prop) {
      if (prop) {
        this.visits = {
          ...this.visits,
          data: await this.visits.data.map((item, index) => {
            if (entryIndex === index) {
              item = {
                ...item,
                ...prop,
              };
            }
            return item;
          }),
        };
      }
    },
    async getFilteredVisitTypeOptions(item, index) {
      this.getEndHour(item, index);
      await this.getPractitionerList(item);
      const visitDate = new Date(
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        item.day
      );
      this.visitTypesOptions = (
        await visitRegistryService.getVistTypes(
          this.compensatoryInfo?.requestTypeId ??
            this.studentInfo.requestTypeId,
          this.studentInfo.disciplineTypeId,
          this.studentInfo.academicYearId,
          visitDate,
          this.studentInfo.schoolTypeId
        )
      ).data;
    },
    async evalEnterDay(item, index) {
      if (!item.id) {
        item.selectedType = null;
      }
      await this.getFilteredVisitTypeOptions(item, index);
    },
    evalEnterHour(item, index) {
      const valueHour = parseInt(item.hourStartHour);
      const ampmResult = this.getAmPm(valueHour);

      //update visit entry for initial values
      item.ampmDisabled = ampmResult.disabled;
      item.hourStartTime = ampmResult.time;

      //eval get end hour
      this.getEndHour(item, index);
    },
    evalEnterMinute(item, index) {
      this.getEndHour(item, index);
    },
    evalEnterAmPm(item, index) {
      this.getEndHour(item, index);
    },
    getEndHour(item, index) {
      if (this.showHasta) {
        return;
      }

      if (item.day && item.hourStartHour && item.hourStartMinute) {
        let minutesDuration = this.getMinuteDurationForDateEntry(item.day);
        const entryValues = this.getEntryValues(item);
        if (minutesDuration && entryValues) {
          let visitDate = this.getVisitDate(item.day);
          let newDateTime = this.addMinutes(
            visitDate,
            entryValues,
            minutesDuration
          );

          let endHour = moment(newDateTime, 'hh').format('hh');
          const ampmResult = this.getAmPm(endHour);

          this.updateVisitEntry(index, {
            hourEnd: moment(newDateTime, 'hh:mm A').format('hh:mm A'),
            hourEndTime: ampmResult.time,
          });
        }
      }
    },
    getMinuteDurationForDateEntry(entryDay) {
      let visitDate = this.getVisitDate(entryDay);
      return this.lookUpVisitDayReferralVisitDuration(visitDate);
    },
    getVisitDate(visitday) {
      if (!visitday) {
        return null;
      }
      return new Date(
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        parseInt(visitday)
      );
    },
    lookUpVisitDayReferralVisitDuration(visitDate) {
      let referrals = this.lookUpVisitDayReferrals(visitDate);
      if (referrals == null || referrals.length < 1 || referrals.length > 1) {
        return null;
      }
      return referrals[0].minuteAmt;
    },
    lookUpVisitDayReferrals(visitDate) {
      if (this.referralForVisits.length == 0) {
        return null;
      }
      const referralsForVisit = [];
      let referralsList = this.referralForVisits;
      for (let idx = 0; idx < referralsList.length; idx++) {
        let ref = referralsList[idx];
        if (
          moment(visitDate).isBetween(
            moment(ref.effectiveDateFrom, 'DD/MMM/YYYY'),
            moment(ref.effectiveDateTo, 'DD/MMM/YYYY'),
            'days',
            '[]'
          )
        ) {
          referralsForVisit.push(ref);
        }
      }
      return referralsForVisit;
    },
    getEntryValues(item) {
      return {
        hour: item.hourStartHour,
        min: item.hourStartMinute,
        ampm: item.hourStartTime,
      };
    },
    //utilities method
    addMinutes(date, startTime, minutesToAdd) {
      let dateTime = this.getDateTime(date, startTime);
      dateTime.setMinutes(dateTime.getMinutes() + minutesToAdd);
      return dateTime;
    },
    getDateTime(date, startTime) {
      let theHour = parseInt(startTime.hour);
      let theMin = parseInt(startTime.min);
      if (startTime.ampm == 'pm') {
        if (theHour != 12) {
          theHour += 12;
        }
      } else if (startTime.ampm == 'am') {
        if (theHour == 12) {
          theHour = 0;
        }
      }
      date.setHours(theHour, theMin);
      return date;
    },
    getAmPm(valueHour) {
      let result = { time: 'am', disabled: true };
      if (valueHour == 12 || (valueHour >= 1 && valueHour <= 6)) {
        result.time = 'pm';
      } else if (valueHour >= 8 && valueHour <= 11) {
        result.time = 'am';
      } else {
        result.disabled = false;
      }
      return result;
    },
    afterRemoveHandler(item, itemIndex) {
      this.updateVisitEntry(itemIndex, {
        isDocumentRemoved: true,
      });
    },
    getDurationInMinutes(item) {
      var dateTime = moment([
        this.selectedPeriod.year,
        this.selectedPeriod.monthNumber - 1,
        item.day,
      ]);

      const timeStartFull = dateTime
        .set({ hour: item.hourStartHour, minute: item.hourStartMinute })
        .toDate();

      const timeEndFull = this.showHasta
        ? dateTime
            .set({
              hour: item.hourEnd,
              minute: item.hourEndMinute,
            })
            .toDate()
        : dateTime
            .set({
              hour: moment(item.hourEnd, 'hh:mm A').format('hh'),
              minute: moment(item.hourEnd, 'hh:mm A').format('mm'),
            })
            .toDate();

      var diffMs = (timeEndFull - timeStartFull) / 1000;

      diffMs /= 60;
      var diffMins = Math.round(diffMs);

      return diffMins;
    },
    async exceedDayMinutes(admissionId, visitDate, item) {
      const { data: result } = await visitRegistryApi.getDayVisitsDuration(
        admissionId,
        visitDate
      );
      let newVisitDuration = this.getDurationInMinutes(item);

      let currentMinutes = 0;

      if (item.id) {
        const hourStartFormat = moment().set({
          hour: item.visitTimeStart.hours,
          minute: item.visitTimeStart.minutes,
        });

        const hourEndFormat = moment().set({
          hour: item.visitTimeEnd.hours,
          minute: item.visitTimeEnd.minutes,
        });

        currentMinutes = hourEndFormat.diff(hourStartFormat, 'minutes');
      }

      const validList = [
        visitTypes.VisitaReposicion,
        visitTypes.VisitaReposicion_AnoAnterior,
        visitTypes.Ciberterapia_Reposicion_Ano_Actual,
        visitTypes.Ciberterapia_Reposicion_Ano_Anterior,
      ];

      if (validList.includes(item.selectedType.id)) {
        newVisitDuration = 0;
      }

      return (
        result + newVisitDuration - currentMinutes > this.studentInfo.minuteAmt
      );
    },
    disableAmPm(item) {
      if (
        item.hourStartHour == 12 ||
        (item.hourStartHour >= 1 && item.hourStartHour <= 6) ||
        (item.hourStartHour >= 8 && item.hourStartHour <= 11)
      ) {
        return true;
      } else {
        return false;
      }
    },
    parseHour(time, hour) {
      if (hour == 12) {
        return parseInt(hour);
      }
      return time.toLowerCase() == 'pm' ? parseInt(hour) + 12 : hour;
    },
  },
};
</script>

<style scoped src="@/assets/css/component/radio-button.css"></style>
<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 86px;
  .toggle-icon {
    flex: 1;
    cursor: pointer;
    text-align: center;
    em {
      margin-top: 12px;
      font-size: 26px;
    }
  }
  .separator-line {
    background: transparent linear-gradient(270deg, #f7f7f700 0%, #efefef 100%)
      0% 0% no-repeat padding-box;
    opacity: 1;
    width: 10px;
    height: 100%;
  }
}
.orange-color {
  color: #ff7058;
}
.green-color {
  color: #2db782;
}
.hour-size {
  width: 60px;
  margin-right: 10px;
}
.ampm-size {
  width: 80px;
  margin-right: 10px;
}

/* overrides */
.custom-callout {
  .col-spacing {
    padding: 20px 15px;
  }
  ::v-deep .callout-container {
    padding: 0px !important;
    border-left-width: 0px;
  }
  ::v-deep .collaut-edition {
    margin-top: 3px !important;
    padding: 7px !important;
  }
}

::v-deep .custom-nav-container {
  border-bottom: 1px solid map-get($colors, 'gray-5');
  .nav-item {
    .nav-link {
      color: map-get($colors, 'secondary-6');
      &.active {
        border-bottom: 3px solid map-get($colors, 'green');
        color: map-get($colors, 'green');
      }
      &.active:after {
        content: unset;
      }
    }
  }
}

.custom-dropdown-container {
  max-width: 250px;
  min-width: 250px;
  .dropdown-item {
    white-space: unset;
    padding: 0.25rem 1rem;
    em {
      margin-right: 10px;
    }
  }
}

.visit-error-container {
  background: #fae7e7;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  margin-top: -16px;
  margin-bottom: 20px;
}

.input-group .entry {
  height: 25px;
  position: relative;
  width: 110px;
}
.input-group .circle {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  position: absolute;
  transition: border-color 300ms;
  width: 20px;
}
.input-group .entry-label {
  cursor: pointer;
  font-weight: 800;
  margin-top: -3px;
  padding-left: 30px;
  user-select: none;
  -moz-user-select: none;
}
.input-group .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 5px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}
.input-group .hidden:nth-child(1):checked ~ .highlight {
  transform: translateY(0);
}
.input-group .hidden:nth-child(3):checked ~ .highlight {
  transform: translateX(110px);
}
.input-group .hidden:nth-child(1):checked + .entry .circle {
  border-color: #e2e2e2;
}
</style>
